<template>
    <v-form>
        <v-card-text>
            <v-subheader>
                <h3> Auto Refresh</h3>
            </v-subheader>
            <v-select
                v-model="autoRefreshMinutes"
                :items="refreshItems"
                item-text="text"
                item-value="value"
                label="Auto Refresh"
                dense
                outlined
                @change="updateAutoRefresh"
            />
        </v-card-text>
        <v-card-text>
            <v-subheader>
                <h3> Default Sort</h3>
            </v-subheader>
            <v-select
                v-model="orderBy"
                :items="sortItems"
                item-text="text"
                item-value="value"
                label="Default sort"
                dense
                outlined
                @change="updateDefaultSort"
            />
        </v-card-text>
    </v-form>
</template>
<script>
export default {
    props: {
        config: {
            type: Object,
            required: true,
        },
    },
    data(){
        return{
            sortItems: [
                { value: 'received-asc', text: 'Received Date' },
                { value: 'received-desc', text: 'Received Date (Desc)' },
                { value: 'ticket-asc', text: 'Ticket Number, Revision' },
                { value: 'ticket-desc', text: 'Ticket Number, Revision (Desc)' },
                { value: 'address-asc', text: 'Address (State, County, Place, Street)' },
                { value: 'address-desc', text: 'Address (State, County, Place, Street) (Desc)' },
                { value: 'seq_date-asc', text: 'Sequence (Date, Number)' },
                { value: 'seq_date-desc', text: 'Sequence (Date, Number) (Desc)' },
                { value: 'due_date-asc', text: 'Due Date' },
                { value: 'due_date-desc', text: 'Due Date (Desc)' },
                { value: 'work_date-asc', text: 'Work Date' },
                { value: 'work_date-desc', text: 'Work Date (Desc)' },
                { value: 'updated-asc', text: 'Updated Date' },
                { value: 'updated-desc', text: 'Updated Date (Desc)' },               
                { value: 'TR_insight_risk_score-asc', text: 'Insight Risk Score' },
                { value: 'TR_insight_risk_score-desc', text: 'Insight Risk Score (Desc)' },
                { value: 'priority-asc', text: 'Priority, Type, Category, Received' },
                { value: 'priority-desc', text: 'Priority DESC, Type, Category, Received' },
                { value: 'type-asc', text: 'Type, Priority, Category, Received' },
                { value: 'type-desc', text: 'Type DESC, Priority, Category, Received' }
            ],
            refreshItems: [
                { value: 0, text: 'Off' },               
                { value: 2, text: '2 Minutes' },
                { value: 5, text: '5 Minutes' },
                { value: 10, text: '10 Minutes' },
                { value: 15, text: '15 Minutes' },
                { value: 30, text: '30 Minutes' },
                { value: 60, text: '60 Minutes' },
            ],
        };
    },
    computed: {
        autoRefreshMinutes: {
            get() {
                return this.config.autoRefreshMinutes ? this.config?.autoRefreshMinutes : 0;
            },
            set(value) {
                this.config.autoRefreshMinutes = value;                
            },
        },
        orderBy: {
            get() {               
                return this.config.orderBy ? this.config?.orderBy : 'seq_date-desc';
            },
            set(value) {
                this.config.orderBy = value;
            },
        },
    },
      
    methods:{
        updateDefaultSort(orderBy){           
            this.$emit('updateDefaultSort', orderBy);
        },
        updateAutoRefresh(autoRefreshMinutes){
            this.$emit('updateAutoRefresh', autoRefreshMinutes);
        },
    }
};
</script>
<style scoped>
.v-subheader {
    padding: 0px;
    align-items: normal;
}
</style>
